import { render, staticRenderFns } from "./SidebarEditAddress.vue?vue&type=template&id=eefa13c8&scoped=true&"
import script from "./SidebarEditAddress.vue?vue&type=script&lang=js&"
export * from "./SidebarEditAddress.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditAddress.vue?vue&type=style&index=0&id=eefa13c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefa13c8",
  null
  
)

export default component.exports